import React from 'react'
import { StyleSheet, Image } from 'react-native'
import { DNABox, DNAText, Iffy } from '@alucio/lux-ui'

const styles = StyleSheet.create({
  aiLoadingImage: {
    width: 300,
    height: 300,
  },
  container: {
    minHeight: 400,
  },
  innerContainer: {
    padding: 48,
  },
  messageText: {
    textAlign: 'center',
  },
})

interface AILoadingProps {
  message?: string
  imageSize?: number
  compact?: boolean
}

export const AILoadingAnimation: React.FC<AILoadingProps> = ({ message, imageSize, compact }) => {
  const resolvedImageSize = imageSize ?? (compact ? 32 : undefined)
  const imageSizeStyle = React.useMemo(
    () =>
      resolvedImageSize == null
        ? undefined
        : {
          width: resolvedImageSize,
          height: resolvedImageSize,
        },
    [resolvedImageSize],
  )

  const content = (
    <>
      <Image
        style={[styles.aiLoadingImage, imageSizeStyle]}
        source={require('../../../assets/images/aiLoading.gif')}
      />
      <Iffy is={!!message}>
        <DNABox appearance="col" alignY="center" alignX="center">
          <DNAText h4 style={styles.messageText}>
            {message}
          </DNAText>
        </DNABox>
      </Iffy>
    </>
  )

  if (compact) {
    return content
  }

  return (
    <DNABox fill alignY="center" alignX="center" style={styles.container}>
      <DNABox
        appearance="col"
        alignX="center"
        alignY="center"
        spacing="md"
        style={styles.innerContainer}
      >
        {content}
      </DNABox>
    </DNABox>
  )
}
